// Revue du lot B (sous-plan 10) : dans l'iframe de l'app, « Copier le lien » donne l'adresse de la page
// Assistant de l'app avec la conversation en retour (parametre retour, lu par la route /assistant), pas
// la page Dust directe qui sortirait le membre de l'app. Hors iframe, ou sans app : le lien de Dust.
export function lienDeConversation(
  lienDust: string,
  appUrl: string | null,
  integre: boolean
): string {
  if (!integre || !appUrl) {
    return lienDust;
  }
  let chemin: string;
  try {
    chemin = new URL(lienDust).pathname;
  } catch {
    return lienDust;
  }
  return `${appUrl.replace(/\/+$/, "")}/assistant?retour=${encodeURIComponent(chemin)}`;
}
